import { Box, Button, Flex } from 'styling/GlobalStyles'
import { BedStatusChip, Container, ContainerContent, ContainerHeader, HeaderButton, IconContainer, PersonChip, SelectedEmployeeImage, StepNumber } from '../Accommodation.style'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { useState } from 'react'
import { NextIcon } from '../icons/NextIcon'
import { Input } from 'components/Input/Input'
import { WhitePersonIcon } from '../icons/WhitePersonIcon'
import Avatar from '../../../assets/images/profileAvatar.png'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { ConfirmCheckInModal } from '../ConfirmCheckInModal'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'


const EmployeeSelect = ({ setSelectedEmployee, selectedEmployee, setStep }) => {
    const Option = () => {
        return <Box style={{ cursor: 'pointer' }} >
            <Flex column gap='0.5rem' >
                <TitleText>John Smith</TitleText>
                <BodyText grey>Male • Standard</BodyText>
            </Flex>
        </Box>
    }
    return <>
        <TitleText style={{ fontSize: 18 }} >Search Employee</TitleText>
        <BodyText grey>Search from HRDL system</BodyText>

        <HonestSelectAsyncInput
            nomarg
            link='users/basic'
            name='employee'
            onChange={(v) => setSelectedEmployee({ ...v })}
            defaultValue={selectedEmployee?.label}
            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, value: i.id, id: i.accessCardId, role: i.role }))}
        />
        <Button orange mt='16' disabled={!selectedEmployee?.value} onClick={() => setStep(2)} width='100%' >Save</Button>
        <OtherText grey style={{ margin: '1rem 0' }} >QUICK SELECT</OtherText>
        <Option />
        <Option />
        <Option />
    </>
}


const SelectPerson = ({ setType, type, setGuest, guest, setSelectedEmployee, selectedEmployee, setStep }) => {


    return <Container>
        <ContainerHeader>
            <HeaderButton active={type === 'Employee'} onClick={() => setType('Employee')} >Employee</HeaderButton>
            <HeaderButton active={type === 'Guest'} onClick={() => setType('Guest')} >Guest</HeaderButton>
        </ContainerHeader>
        <ContainerContent style={{ gap: '0.5rem' }} >
            {type == 'Employee' ? <EmployeeSelect setSelectedEmployee={setSelectedEmployee} selectedEmployee={selectedEmployee} setStep={setStep} /> : <GuestSelect setGuest={setGuest} setStep={setGuest} guest={guest} />}
        </ContainerContent>
    </Container>
}

const GuestSelect = ({ guest, setGuest, setStep }) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target
        setGuest(prev => ({ ...prev, [name]: value }))
    }

    const handleSelect = (v: ISelectValue, name: string) => {
        setGuest(prev => ({ ...prev, [name]: v }))
    }

    const handleDate = (date: Date, name: string) => {
        setGuest(prev => ({ ...prev, [name]: date }))
    }

    return <>
        <TitleText style={{ fontSize: 18 }} >Guest Registration</TitleText>
        <BodyText grey>Manual entry for non-employee guests</BodyText>
        <Flex column gap='1rem' >
            <Flex width='100%' gap='1rem' >
                <Input onChange={handleChange} value={guest.firstName} name='firstName' labelText='First Name' nomarg placeholder='Enter here...' />
                <Input onChange={handleChange} value={guest.lastName} name='lastName' labelText='Last Name' nomarg placeholder='Enter here...' />
            </Flex>
            <Flex width='100%' gap='1rem' >
                <HonestSelectInput options={genderOptions} labelText='Gender' defaultValue={guest?.gender?.value} name='gender' onChange={handleSelect} nomarg />
                <HonestSelectInput onChange={handleSelect} options={tierOptions} defaultValue={guest?.gender?.tier} labelText='Tier' name='tier' nomarg />
            </Flex>
            <CalendarInput defaultValue={guest.checkIn} onChange={date => handleDate(date, 'checkIn')} labelText='Check-In' nomarg />
            <CalendarInput defaultValue={guest.checkOut} onChange={date => handleDate(date, 'checkOut')} labelText='Check-Out' nomarg />
            <Button orange width='100%' mt='16' onClick={() => setStep(2)} >Continue With Guest</Button>
        </Flex>

    </>
}

export const CheckIn = () => {
    const [step, setStep] = useState<1 | 2>(1)
    const [type, setType] = useState('Employee')
    const [modal, setModal] = useState({ open: false, value: null })
    const [selectedEmployee, setSelectedEmployee] = useState({
        label: '',
        value: null,
        role: '',
        id: null,
        checkIn: null,
        checkOut: null
    })
    const [guest, setGuest] = useState({
        firstName: '',
        lastName: '',
        gender: null,
        tier: null,
        checkIn: null,
        checkOut: null,
    })

    const Step = ({ step, name, active }) => {
        return <Flex style={{ cursor: 'pointer' }} onClick={() => setStep(step)} center gap='1rem' >
            <StepNumber active={active} >  {step}</StepNumber>
            <BodyText grey={!active} >{name}</BodyText>
        </Flex>
    }



    const NoPersonSelected = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>No person selected</TitleText>
            <BodyText grey>Select a person to view available beds</BodyText>
        </Flex>
    }


    const Bed = () => {
        return <Box width='100%' style={{ cursor: 'pointer' }} onClick={() => setModal({ open: true, value: null })} >
            <Flex column gap='1rem' >

                <Flex between width='100%' >
                    <Flex><TitleText>Bed 1</TitleText></Flex>
                    <BedStatusChip status='Available'>Available</BedStatusChip>
                </Flex>
                <BodyText grey >Male · Standard</BodyText>
                <Flex gap='0.5rem' >
                    <BodyText grey > North Camp </BodyText>
                    <NextIcon />
                    <BodyText grey > Block A </BodyText>
                    <NextIcon />
                    <BodyText grey > Room 1 </BodyText>
                </Flex>
            </Flex>

        </Box>
    }

    const SelectBedEmployee = () => {


        const handleDate = (date: Date, name: string) => {
            setSelectedEmployee(prev => ({ ...prev, [name]: date }))
        }

        return <>
            <Box>
                <Flex gap='1rem' >
                    <SelectedEmployeeImage>
                        <img
                            src={Avatar}
                            alt='profile-image'
                            onError={({ currentTarget }) => (currentTarget.src = Avatar)}
                        />
                    </SelectedEmployeeImage>
                    <Flex column width='100%' gap='0.5rem' >
                        <Flex width='100%' >
                            <OtherText color='#ff9900' >SELECTED PERSON</OtherText>
                        </Flex>
                        <TitleText>{selectedEmployee?.label}</TitleText>
                    </Flex>
                </Flex>
                <Flex mt='16' mb='16' center gap='0.5rem' ><PersonChip type='Employee'>Employee</PersonChip>  <OtherText grey >ID: {selectedEmployee?.id}</OtherText></Flex>
                <Flex width='100%' gap='1rem' >
                    <Box width='100%'>
                        <Flex column gap='0.5rem' >
                            <OtherText grey>Role</OtherText>
                            <TitleText>{selectedEmployee?.role}</TitleText>
                        </Flex>
                    </Box>
                    {/* <Box width='100%' >
                        <Flex column gap='0.5rem' >
                            <OtherText grey>TIER</OtherText>
                            <TitleText>Standard</TitleText>
                        </Flex>
                    </Box>*/}
                </Flex>
            </Box>
            <Box>
                <Flex column gap='0.5rem'>
                    <TitleText style={{ marginBottom: '1rem' }}>Stay Duration</TitleText>
                    <CalendarInput defaultValue={selectedEmployee?.checkIn} onChange={date => handleDate(date, 'checkIn')} labelText='Check-In' nomarg />
                    <CalendarInput defaultValue={selectedEmployee?.checkOut} onChange={date => handleDate(date, 'checkOut')} labelText='Check-Out' nomarg />
                    <Flex mt='32' between width='100%' >
                        <BodyText grey >Total Stay Duration</BodyText>
                        <BodyText  >2 Days</BodyText>
                    </Flex>
                </Flex>

            </Box></>
    }

    const SelectBedGuest = () => {


        return <Box>
            <Flex gap='1rem' >
                <SelectedEmployeeImage>
                    <img
                        src={Avatar}
                        alt='profile-image'
                        onError={({ currentTarget }) => (currentTarget.src = Avatar)}
                    />
                </SelectedEmployeeImage>
                <Flex column width='100%' gap='0.5rem' >
                    <Flex width='100%' >
                        <OtherText color='#ff9900' >SELECTED PERSON</OtherText>
                    </Flex>
                    <TitleText>John Smith</TitleText>
                </Flex>
            </Flex>
            <Flex mt='16' mb='16' center gap='0.5rem' ><PersonChip type='Guest'>Guest</PersonChip>  <OtherText grey >ID: G-005</OtherText></Flex>
            <Flex column gap='1rem' mt='48' >
                <Flex width='100%' gap='1rem' >
                    <Box width='100%'>
                        <Flex column gap='0.5rem' >
                            <OtherText grey>GENDER</OtherText>
                            <TitleText>Male</TitleText>
                        </Flex>
                    </Box>
                    <Box width='100%' >
                        <Flex column gap='0.5rem' >
                            <OtherText grey>TIER</OtherText>
                            <TitleText>Standard</TitleText>
                        </Flex>
                    </Box>
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Box width='100%'>
                        <Flex column gap='0.5rem' >
                            <OtherText grey>Check-In</OtherText>
                            <TitleText>Male</TitleText>
                        </Flex>
                    </Box>
                    <Box width='100%' >
                        <Flex column gap='0.5rem' >
                            <OtherText grey>Check-Out</OtherText>
                            <TitleText>Standard</TitleText>
                        </Flex>
                    </Box>
                </Flex>
            </Flex>
            <Flex mt='32' between width='100%' >
                <BodyText grey >Total Stay Duration</BodyText>
                <BodyText  >2 Days</BodyText>
            </Flex>
        </Box>
    }

    const SelectStayAndDuration = () => {
        return <Container >
            <ContainerContent noHeader gap='1rem'>
                {type == 'Employee' ? <SelectBedEmployee /> : <SelectBedGuest />}
            </ContainerContent>
        </Container>
    }

    return <>
        <Flex mt='32' mb='16' width='100%' between >
            <Flex gap='1rem' center>
                <Step step={1} name='Select Person' active={step === 1} />
                <NextIcon />
                <Step step={2} name='Select Stay Duration and Bed' active={step === 2} />
                {/* <NextIcon />
                <Step step={3} name='Confirm' active={step === 3} /> */}
            </Flex>
        </Flex>
        <Flex width='100%' between gap='1rem'>
            {step == 1 ? <SelectPerson selectedEmployee={selectedEmployee} setGuest={setGuest} guest={guest} setSelectedEmployee={setSelectedEmployee} setStep={setStep} setType={setType} type={type} /> : <SelectStayAndDuration />}
            <Container>
                <ContainerHeader><TitleText style={{ lineHeight: '50px', marginLeft: '1rem' }} >Select Bed</TitleText></ContainerHeader>
                <ContainerContent gap='1rem' >
                    {/* <NoPersonSelected /> */}
                    <Bed />
                    <Bed />
                    <Bed />
                    <Bed />
                    <Bed />
                    <Bed />
                    <Bed />
                </ContainerContent>
            </Container>
        </Flex>
        {modal.open && <ConfirmCheckInModal closeModal={() => setModal({ open: false, value: null })} value={{
            person: 'John Smith',
            type: 'Employee',
            checkIn: '2024-01-01',
            checkOut: '2024-01-03',
            bed: 'Bed 1',
            location: 'Room 101'
        }} />}
    </>
}

const genderOptions = [{ value: 1, label: 'Male' }, { value: 2, label: 'Female' }, { value: 3, label: 'Both' }]

const tierOptions = [{ value: 1, label: 'VIP' }, { value: 1, label: 'SENIOR' }, { value: 1, label: 'Junior' }, { value: 1, label: 'Contractor' }]